import React, { useEffect } from "react";
import { getCommunityFolders } from "../../../../actions/appExpandedActions/communities";
import { connect } from "react-redux";
import DataTable from "../../DataTable/DataTable";

const FoldersCommunities = ({ getCommunityFolders, communityFolders, period }) => {
  useEffect(() => {
    getCommunityFolders({ page: 1, limit: 20 });
  }, []);

  useEffect(() => {
    if (period?.startDate !== "" && period?.startDate !== null) {
      getCommunityFolders({
        page: 1,
        limit: 20,
        startDate: period?.startDate || "",
        endDate: period?.endDate || "",
      });
    }
  }, [period]);

  const handleLoadMore = (page) => {
    getCommunityFolders({
      page,
      limit: 20,
      startDate: period?.startDate || "",
      endDate: period?.endDate || "",
    });
  };

  return (
    <DataTable
      preset="foldersCommunities"
      data={{
        docs: communityFolders?.docs || [],
        totalPages: communityFolders?.totalPages || 0
      }}
      onLoadMore={handleLoadMore}
      loading={false}
    />
  );
};

const mapStateToProps = (state) => ({
  communityFolders: state.appCommunities.communityFolders,
});

const mapDispatchToProps = (dispatch) => ({
  getCommunityFolders: (payload) => dispatch(getCommunityFolders(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FoldersCommunities);
